const column = () => {
  const $pcHeader = $("#header");
  const $container = $("#js-column-header");
  const $window = $(window);
  const headerHeight = Math.ceil($container.innerHeight() - 60);

  $window.on("scroll", () => {
    if (Math.ceil($window.scrollTop()) >= headerHeight) {
      $container.addClass("is-fixed");
      $pcHeader.css("z-index", -100);
    } else {
      $container.removeClass("is-fixed");
      $pcHeader.css("z-index", 100);
    }
  });
};

export default column;
